export class mdlAnnouncementRes{
    Title:string;
    EngMessage:string;
    ArMessage:string;
    StatusCode:string;
    StatusDesc:string;
    FromDate:string;
    ToDate:string;   
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlAnnouncementRes.ts